module.exports = __webpack_public_path__ + "assets/img/mute.3e58fef7.png";